.customer-organization-form__modal-dialog {
  // TODO: there should be better selectors for modal content
  // .telia-react-modalDialog_content_section, .telia-react-modalDialog_container_content don't work for unknown reason
  & > div > div,
  & > div > div > div {
    overflow: visible;
  }

  .customer-organization-form__create-group-user-roles-container {
    margin-top: 2.4rem;
  }
}
